// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addEditActivityModal .react-datepicker__input-container {
  width: 12.2rem;
}

.addEditActivityModal .statusDD {
  width: 12.2rem;
}

.addEditActivityModal {
  width: 450px !important;
}

.addEditActivityModal-toyota .react-datepicker__close-icon::after {
  background-color: #e50000;
}

.addEditActivityModal-lexus .react-datepicker__close-icon::after {
  background-color: #252525;
}

.addEditActivityModal #firstVisit, .addEditActivityModal #completionOn, .addEditActivityModal #reminderOn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right;
  cursor: pointer;
}

.addEditActivityModal-toyota .css-10nd86i svg {
  color: #e50000;
}

.addEditActivityModal-lexus .css-10nd86i svg {
  color: #252525;
}

.addEditActivityModal .css-1492t68 {
  text-indent: -9999px;
}

.addEditActivityModal .css-va7pk8 {
  color: #595d60 !important;
}

.addEditActivityModal .react-autosuggest__container {
  position: relative;
}

.addEditActivityModal .react-autosuggest__input {
  width: 100%;
  padding: 10px 10px;
  border: 1px solid #aaa;
  border-color: rgb(219, 212, 212);
  border-radius: 0.25rem !important;
}

/* .addEditActivityModal .react-autosuggest__input--focused {
    border-radius: 0.25rem !important;
  } */

.addEditActivityModal .react-autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  width: 100%;
  border-radius: 0.25rem !important;
}

/* .addEditActivityModal .react-autosuggest__suggestions-container {
   
  } */

.addEditActivityModal .react-autosuggest__suggestions-container--open {
  display: block;
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 0.25rem !important;
}

.addEditActivityModal .react-autosuggest__suggestions-list {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.addEditActivityModal .react-autosuggest__suggestion {
  cursor: pointer;
  padding: 10px 20px;
}

.addEditActivityModal .react-autosuggest__suggestion--highlighted {
  background-color: #ddd;
}

/*
  ==================================
  Don't change. React calender CSS. 
  */

.react-datepicker {
  font-size: 11px;
}

.react-datepicker__header {
  padding-top: 0.8em;
}

.react-datepicker__month {
  margin: 0.4em 1em;
}

.react-datepicker__day-name, .react-datepicker__day {
  width: 1.9em;
  line-height: 1.9em;
  margin: 0.166em;
}

.react-datepicker__current-month {
  font-size: 1em;
}

.react-datepicker__navigation {
  top: 1em;
  line-height: 1.7em;
  border: 0.45em solid transparent;
}

.react-datepicker__navigation--previous {
  border-right-color: #ccc;
  left: 1em;
}

.react-datepicker__navigation--next {
  border-left-color: #ccc;
  right: 1em;
}

.disableAutoSuggest {
  background-color: hsl(0, 0%, 95%);
  border-color: hsl(0, 0%, 90%);
  color: hsl(0, 0%, 60%);
}

/*
    =================================
  */

.addEditActivityModal-toyota .modal-header {
  background-color: #e50000;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  padding: 0.5rem !important;
}

.addEditActivityModal-lexus .modal-header {
  background-color: #252525;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  padding: 0.5rem !important;
}

.addEditActivityModal-toyota .modal-dialog, .addEditActivityModal-toyota .modal-content {
  border-radius: 24px !important;
  border: 1px solid #e50000 !important;
}

.addEditActivityModal-lexus .modal-dialog, .addEditActivityModal-lexus .modal-content {
  border-radius: 24px !important;
  border: 1px solid #252525 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/activityModal/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;KAEK;;AAEL;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,iCAAiC;AACnC;;AAEA;;KAEK;;AAEL;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,uCAAuC;EACvC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC","sourcesContent":[".addEditActivityModal .react-datepicker__input-container {\n  width: 12.2rem;\n}\n\n.addEditActivityModal .statusDD {\n  width: 12.2rem;\n}\n\n.addEditActivityModal {\n  width: 450px !important;\n}\n\n.addEditActivityModal-toyota .react-datepicker__close-icon::after {\n  background-color: #e50000;\n}\n\n.addEditActivityModal-lexus .react-datepicker__close-icon::after {\n  background-color: #252525;\n}\n\n.addEditActivityModal #firstVisit, .addEditActivityModal #completionOn, .addEditActivityModal #reminderOn {\n  background-image: url(\"../../assets/images/calendar.png\");\n  background-repeat: no-repeat;\n  background-position: right;\n  cursor: pointer;\n}\n\n.addEditActivityModal-toyota .css-10nd86i svg {\n  color: #e50000;\n}\n\n.addEditActivityModal-lexus .css-10nd86i svg {\n  color: #252525;\n}\n\n.addEditActivityModal .css-1492t68 {\n  text-indent: -9999px;\n}\n\n.addEditActivityModal .css-va7pk8 {\n  color: #595d60 !important;\n}\n\n.addEditActivityModal .react-autosuggest__container {\n  position: relative;\n}\n\n.addEditActivityModal .react-autosuggest__input {\n  width: 100%;\n  padding: 10px 10px;\n  border: 1px solid #aaa;\n  border-color: rgb(219, 212, 212);\n  border-radius: 0.25rem !important;\n}\n\n/* .addEditActivityModal .react-autosuggest__input--focused {\n    border-radius: 0.25rem !important;\n  } */\n\n.addEditActivityModal .react-autosuggest__input--open {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  width: 100%;\n  border-radius: 0.25rem !important;\n}\n\n/* .addEditActivityModal .react-autosuggest__suggestions-container {\n   \n  } */\n\n.addEditActivityModal .react-autosuggest__suggestions-container--open {\n  display: block;\n  width: 100%;\n  border: 1px solid #aaa;\n  border-radius: 0.25rem !important;\n}\n\n.addEditActivityModal .react-autosuggest__suggestions-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.addEditActivityModal .react-autosuggest__suggestion {\n  cursor: pointer;\n  padding: 10px 20px;\n}\n\n.addEditActivityModal .react-autosuggest__suggestion--highlighted {\n  background-color: #ddd;\n}\n\n/*\n  ==================================\n  Don't change. React calender CSS. \n  */\n\n.react-datepicker {\n  font-size: 11px;\n}\n\n.react-datepicker__header {\n  padding-top: 0.8em;\n}\n\n.react-datepicker__month {\n  margin: 0.4em 1em;\n}\n\n.react-datepicker__day-name, .react-datepicker__day {\n  width: 1.9em;\n  line-height: 1.9em;\n  margin: 0.166em;\n}\n\n.react-datepicker__current-month {\n  font-size: 1em;\n}\n\n.react-datepicker__navigation {\n  top: 1em;\n  line-height: 1.7em;\n  border: 0.45em solid transparent;\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n  left: 1em;\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: #ccc;\n  right: 1em;\n}\n\n.disableAutoSuggest {\n  background-color: hsl(0, 0%, 95%);\n  border-color: hsl(0, 0%, 90%);\n  color: hsl(0, 0%, 60%);\n}\n\n/*\n    =================================\n  */\n\n.addEditActivityModal-toyota .modal-header {\n  background-color: #e50000;\n  border-top-left-radius: 20px !important;\n  border-top-right-radius: 20px !important;\n  padding: 0.5rem !important;\n}\n\n.addEditActivityModal-lexus .modal-header {\n  background-color: #252525;\n  border-top-left-radius: 20px !important;\n  border-top-right-radius: 20px !important;\n  padding: 0.5rem !important;\n}\n\n.addEditActivityModal-toyota .modal-dialog, .addEditActivityModal-toyota .modal-content {\n  border-radius: 24px !important;\n  border: 1px solid #e50000 !important;\n}\n\n.addEditActivityModal-lexus .modal-dialog, .addEditActivityModal-lexus .modal-content {\n  border-radius: 24px !important;\n  border: 1px solid #252525 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
